import React from "react";
import PettyCashApproval from "./PettyCashApproval";

const PettyCashFinanceApproval = () => <PettyCashApproval role="finance" />;

export default PettyCashFinanceApproval;
